<template>
  <div class="modal-wrapper cvLRVf dTIQsR">
    <div class="modal-backdrop fade in" @click="$emit('close')"></div>
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- 弹窗头部 -->
          <div class="jENZOg">
            <div></div>
            <div class="close-button">
              <a @click.stop="$emit('close')" role="button" tabindex="0">
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" class="bnCywO hGsgfJ">
                  <path d="m6 6 20 20M26 6 6 26"></path>
                </svg>
              </a>
            </div>
          </div>

          <!-- 弹窗内容 -->
          <div class="kkluyX">
            <div class="favorite-content">
              <h2 class="favorite-title">Oh Hey!</h2>
              <p class="favorite-description">Like what you see? You just need to log in to favorite deals.</p>
              
              <div class="favorite-buttons">
                <button class="btn-signup" @click="handleSignup">Sign up</button>
                <button class="btn-login" @click="handleLogin">Log in</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FavoriteModal',
  methods: {
    handleSignup() {
      this.$emit('close')
      this.$emit('showSignup')
    },
    handleLogin() {
      this.$emit('close')
      this.$emit('showLogin')
    }
  }
}
</script>

<style scoped>
.favorite-content {
  text-align: center;
  padding: 20px 0;
}

.favorite-title {
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 20px 0;
  color: #000;
}

.favorite-description {
  font-size: 16px;
  color: #222;
  margin: 0 0 30px 0;
  line-height: 1.5;
}

.favorite-buttons {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 400px;
  margin: 0 auto;
}

.btn-signup,
.btn-login {
  width: 100%;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-signup {
  background: #000;
  color: #fff;
}

.btn-signup:hover {
  background: #222;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-login {
  background: #fff;
  color: #000;
  border: 1px solid #000;
}

.btn-login:hover {
  background: #f7f7f7;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.btn-signup:active,
.btn-login:active {
  transform: translateY(0);
}

@media (max-width: 767px) {
  .favorite-title {
    font-size: 28px;
  }

  .favorite-description {
    font-size: 14px;
  }

  .favorite-buttons {
    max-width: 100%;
  }
}
</style>
